import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'esp-error-snackbar',
    imports: [TranslateModule, MatButtonModule],
    templateUrl: './error-snackbar.component.html',
    styleUrl: './error-snackbar.component.scss',
    host: { class: 'error-message' },
})
export class ErrorSnackbarComponent {}
